import { useEffect } from 'react';

export const useVisibleMentions = (open, list, items, markSeen) => {
  useEffect(() => {
    if (!open || !items.length) return;
    const readVisible = () => {
      if (document.hidden || !list.current || document.querySelector('[role=dialog]')) return;
      const root = list.current.getBoundingClientRect();
      const visible = items.filter(({ message_id }) => {
        const row = document.querySelector(`[data-testid="chat-message-${message_id}"]`);
        if (!row) return false;
        const box = row.getBoundingClientRect();
        const overlap = Math.min(root.bottom, box.bottom) - Math.max(root.top, box.top);
        return box.height > 0 && overlap >= Math.min(box.height / 2, root.height / 2);
      }).map((item) => item.message_id);
      if (visible.length) markSeen(visible);
    };
    const timer = setInterval(readVisible, 650);
    return () => clearInterval(timer);
  }, [open, list, items, markSeen]);
};